<template>
  <v-dialog :value="value" max-width="640" @input="$emit('input', $event)">
    <v-card class="pa-2">
      <v-card-title class="text-uppercase">{{ title }}</v-card-title>
      <hr class="my-2" />
      <v-card-text>
        <v-btn-toggle v-model="background" mandatory dense class="mb-3">
          <v-btn small value="checker" title="Fondo de cuadrícula">Cuadrícula</v-btn>
          <v-btn small value="light" title="Fondo claro">Claro</v-btn>
          <v-btn small value="dark" title="Fondo oscuro">Oscuro</v-btn>
        </v-btn-toggle>
        <v-sheet
          outlined
          rounded
          height="320"
          :style="backgroundStyle"
          class="d-flex align-center justify-center pa-4"
        >
          <img v-if="src" :src="src" :alt="title" :style="imgStyle" />
        </v-sheet>
      </v-card-text>
      <hr class="my-2" />
      <v-card-actions class="justify-end">
        <v-btn text color="primary" rounded :href="src" target="_blank" rel="noopener" :disabled="!src">
          <v-icon small left>mdi-open-in-new</v-icon>
          Abrir en el navegador
        </v-btn>
        <v-btn color="primary" rounded @click="$emit('input', false)">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { PREVIEW_BOX_STYLE, PREVIEW_IMG_STYLE } from '../utils/image-preview.styles';

const BACKGROUNDS = {
  checker: PREVIEW_BOX_STYLE,
  light: { backgroundColor: '#fff' },
  dark: { backgroundColor: '#121212' }
};

/**
 * Visor ampliado de una imagen (logo, ícono) con fondo intercambiable, para revisar
 * imágenes blancas o transparentes, y enlace para abrirla en otra pestaña.
 * `v-model` controla si está abierto.
 */
export default {
  name: 'ImagePreviewDialog',

  props: {
    value: { type: Boolean, default: false },
    src: { type: String, default: null },
    title: { type: String, default: 'Vista previa' }
  },

  data() {
    return { background: 'checker', imgStyle: PREVIEW_IMG_STYLE };
  },

  computed: {
    backgroundStyle() {
      return BACKGROUNDS[this.background];
    }
  }
};
</script>
